import {
	ChatAltIcon,
	ClipboardCheckIcon,
	ClipboardListIcon,
	LockClosedIcon,
	LoginIcon,
	UserCircleIcon
} from "@heroicons/react/outline";
import { Link, useMatch } from "react-router-dom";
import { Nav } from "react-bootstrap";

import { useAuth } from "../../services/wp.auth.service";
import { useMemo } from "react";
import { userCanRegister } from "../../helpers/authHelpers";

const menuItems = [
	{
		attendeesOnly: true,
		icon: <ClipboardListIcon />,
		text: "My Classes",
		to: "/account/classes"
	},
	{
		attendeesOnly: true,
		icon: <ClipboardCheckIcon />,
		text: "Past Classes",
		to: "/account/past-classes"
	},
	{
		icon: <UserCircleIcon />,
		text: "My Profile",
		to: "/account/profile"
	},
	{
		icon: <LockClosedIcon />,
		text: "My Account",
		to: "/account/manage"
	},
	{
		attendeesOnly: true,
		icon: <ChatAltIcon />,
		text: "Communications",
		to: "/account/communications"
	},
	{
		icon: <LoginIcon />,
		text: "Logout",
		to: "/logout"
	}
];

const MyAccountNavigation = () => {
	const { user } = useAuth();
	const canRegister = useMemo(() => userCanRegister(user), [user]);

	return (
		<Nav className="flex-column my-account-navigation">
			{
				// eslint-disable-next-line no-extra-parens
				menuItems.map((item) => (!item.attendeesOnly || (item.attendeesOnly && canRegister)) && (
					<Nav.Link
						active={useMatch(item.to)}
						as={Link}
						className="px-0 d-flex align-items-center"
						eventKey={item.to}
						key={item.to}
						to={item.to}
					>
						{item.icon}

						<span className="text-neutral3">
							{item.text}
						</span>
					</Nav.Link>
				))
			}
		</Nav>
	);
};

export default MyAccountNavigation;
